<template>
  <div id="app">
                  <nav class="navbar">
                <div class="container">
                    <div class="navbar-brand">
                        <a class="navbar-item" href="/">
                            <img src="https://mindfuldevmag.com/logo-white.png" alt="MindfulDevMag logo">
                        </a>
                        <span @click.prevent="isActiveNavBurger = !isActiveNavBurger" v-bind:class="{'is-active': isActiveNavBurger}" class="navbar-burger burger" data-target="navbarMenu">
            <span></span>
                        <span></span>
                        <span></span>
                        </span>
                    </div>
                    <div id="navbarMenu" class="navbar-menu" v-bind:class="{'is-active': isActiveNavBurger}">
                      <div class="navbar-start">
                            <a class="navbar-item">Mindful Eating App</a>
                        </div>
                        <div class="navbar-end">
                          <router-link to="/" class="navbar-item">Home</router-link>
                          <router-link to="/dashboard" class="navbar-item">Dashboard</router-link>
                        </div>
                    </div>
                </div>
            </nav>

    <router-view/>
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'Home',
  components: {
    
  },
  data: function() {
    return {
      isActiveNavBurger: false,
    }
  },
}
</script>
<style>

</style>
